<highcharts-chart
    *ngIf="updateChart"
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    [style.height]="height"
    [style.margin-top]="marginTop"
    style="width: 100%; display: block;"
></highcharts-chart>
